import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../components/ui/Button";
import {
  createCmsService,
  getCmsService,
} from "redux/services/general_service";
import TermsDisplay from "./components/TermsDisplay";
import TermsModal from "./components/TermsModal";

import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const TermsAndConditionsManagment = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { cms } = useSelector((state) => state.general);

  const [showModal, setShowModal] = useState(false);
  const [editingPolicy, setEditingPolicy] = useState(null);

  useEffect(() => {
    dispatch(getCmsService());
  }, [dispatch]);

  // حفظ التعديلات
  const handleSave = (policyData) => {
    // هنا ممكن تعمل dispatch لإنشاء أو تعديل السياسة
    console.log("Saved Policy Data:", policyData);
    dispatch(
      createCmsService({
        type: "terms_and_conditions",
        content: policyData?.content,
      }),
    ).then((response) => {
      console.log(response);
      if (response?.payload?.status == 200) {
        toast.success(t("تم"));
        dispatch(getCmsService());
        setEditingPolicy(null);
        setShowModal(false);
      } else {
        console.log(response);
        Object.values(response.payload.errors)
          .flatMap((errorArray) => errorArray)
          .forEach((error) => toast.warn(error));
      }
    });
  };

  // فتح المودال مع النص الحالي للتعديل

  console.log(cms);
  const termsConditions = Array.isArray(cms)
    ? cms.find((item) => item.type === "terms_and_conditions")
    : null;

  const handleEdit = () => {
    setEditingPolicy({
      title: " الشروط والأحكام –مجمع الأمير المنزلي",
      content: termsConditions?.content,
    });
    setShowModal(true);
    console.log(editingPolicy);
  };
  return (
    <div className="p-6">
      <div className="flex justify-between mb-6">
        <h1 className="text-2xl font-bold"> الشروط والأحكام</h1>
        <div className="flex gap-3">
          <Button onClick={handleEdit}>
         تعديل الشروط والأحكام
          </Button>
        </div>
      </div>

      {/* عرض سياسة الخصوصية */}
      <TermsDisplay privacyPolicy={termsConditions} />

      {/* مودال الإضافة/التعديل */}
      <TermsModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        policy={editingPolicy}
        onSave={handleSave}
      />
    </div>
  );
};

export default TermsAndConditionsManagment;
